export const environment = {
  name: 'prod',
  version: '1.0.0',
  production: true,
  serverUrl: 'https://api.belpost.by/api',
  blogUrl: 'https://blog.belpost.by',
  langs: ['ru', 'by', 'en'],
  localStorageKeys: {
    lang: 'lang',
    userAgreementUpdatingModalDismiss: 'user-agreement-updating-modal-dismiss',
  },
  socket: {
    enabled: true,
    encrypted: true,
    url: 'ws.belpost.by',
    port: 443,
    auth: {
      url: 'api.belpost.by',
      port: 443,
    },
  },
  navekConnect: false,
  serviceWorker: false,
  gtag: {
    site: 'UA-137896022-1',
    blog: 'UA-137896022-2',
  },
  gtm: {
    site: 'GTM-KQSL5J4',
    blog: '',
  },
  metrika: { site: '68971627', blog: '68971627' },
  payment: true,
  sentry: {
    enabled: true,
    dsn: 'https://8696beeadbbbf333fff968f7f75a2b43@mysentry.naveksoft.com/14',
  },
  showShopLink: false,
  indexing: true,
  showTranslateDebug: false,
  showContest: true,
  showTracksRangeTab: true,
  showTracksBatchTab: false,
  saveTokenCookie: true,
  showConsoleErrors: false,
  showParcelLockers: false,
  appointmentAvailable: true,
  showECheck: true,
  showCargo: true,
  showPublications: false,
  fullPostalDelivery: true,
  showAppleWallet: false,
  showApplications: true,
  showPreRegistration: true,
  preRegistrationRecordServices: 244,
  informatorsId: 236,
  recipientOnly: true,
  isQrBoxAvailable: true,
  isQrBoxAvailableForLegalPerson: true,
};
